import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PlayIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';

import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';
import {
    showVideoPlayer,
    showVideoPlayerForCircuitBuilder,
    closeVideoPlayer
} from '../../../common/VideoPlayerUtil';

class ExerciseVideoThumbnail extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isVideoPlayerOpen: false
        };
    }

    handleVideoClick = e => {
        if (this.state.isVideoPlayerOpen) {
            closeVideoPlayer();
            return;
        }

        this.setState({ isVideoPlayerOpen: true });

        const anchorElement =
            this.props.videosWrapperRef && this.props.videosWrapperRef.current
                ? this.props.videosWrapperRef.current
                : e.currentTarget;

        if (this.props.isInCircuitBuilder) {
            showVideoPlayerForCircuitBuilder(
                this.props.exercise.video_url,
                anchorElement,
                this.handleVideoClose.bind(this)
            );
        } else {
            showVideoPlayer(
                this.props.exercise.video_url,
                anchorElement,
                this.handleVideoClose.bind(this)
            );
        }
    };

    handleVideoClose = () => {
        this.setState({ isVideoPlayerOpen: false });
    };

    deleteExercise() {
        let block = this.props.block;
        let exercise = this.props.exercise;
        if (this.props.onDelete) {
            this.props.onDelete(exercise);
        } else {
            DesignerState.savingState(block, true);
            DesignerState.deleteExercise(block, exercise);
        }
    }
    stillSaving() {
        let dispatch = this.props.dispatch;
        DesignerState.waitingState(dispatch);
    }
    render() {
        Console.render('designer.ExerciseVideoThumbnail');

        let exercise = this.props.exercise;
        let uiSaving = this.props.uiSaving;
        let defaultThumbURL =
            'https://static.trainheroic.com/ch-images/video_thumb.png';

        let imageWrapper = exercise.video_url ? (
            <div className="image-wrapper">
                <div className="image-wrapper videoThumbnailContainer">
                    <button
                        className="playExerciseIcon"
                        onClick={this.handleVideoClick}
                    >
                        {this.state.isVideoPlayerOpen ? (
                            <StopIcon />
                        ) : (
                            <PlayIcon />
                        )}
                    </button>
                    <img
                        src={exercise.video_thumbnail || defaultThumbURL}
                        alt={exercise.title}
                    />
                </div>
            </div>
        ) : null;

        let disableDelete = uiSaving
            ? 'disable-delete chip-delete'
            : 'chip-delete';
        let eventAllowed = uiSaving
            ? this.stillSaving.bind(this)
            : this.deleteExercise.bind(this);

        let deleteButton = !this.props.hideDelete && (
            <span className={disableDelete} onClick={eventAllowed}>
                <i className="mdi mdi-delete" />
            </span>
        );
        let videoTitle = <p>{exercise.title}</p>;

        return (
            <div className="exercise-chip-row layout-row">
                {exercise.video_url && (
                    <div
                        className={`exercise-chip layout-row${
                            this.props.horizontal ? ' horizontal' : ''
                        }${this.props.isLast ? ' last' : ''}`}
                    >
                        {imageWrapper}
                        {videoTitle}
                        {deleteButton}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToExercisePlainProps = (state, ownProps) => {
    const exercise = ownProps.exercise;
    let swapExercises = [];
    if (exercise && exercise.exercise_id) {
        const libraryExercise = state.library.exerciseRef.find(
            e => e.id === exercise.exercise_id
        );
        if (libraryExercise && libraryExercise.swaps) {
            swapExercises = libraryExercise.swaps;
        }
    }
    return {
        swapExercises,
        ...ownProps
    };
};

export default connect(mapStateToExercisePlainProps)(ExerciseVideoThumbnail);



// WEBPACK FOOTER //
// ./src/view/designer/components/Exercise/ExerciseVideoThumbnail.jsx